import React from "react";
import {
  Box,
  Toolbar,
  CircularProgress,
  Typography,
  Fade,
} from "@mui/material";
import CameraGrid from "./CameraGrid";

const MainContent = ({
  loading,
  selectedPlace,
  cameras,
  searchCamera,
  columnCount,
  gridSize,
  theme,
  onCameraClick,
}) => {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        p: 3,
        mt: {
          xs: "6px",
          sm: "14px",
          md: "22px",
        },
        height: {
          xs: "calc(100vh - 6px)",
          sm: "calc(100vh - 14px)",
          md: "calc(100vh - 22px)",
        },
        backgroundColor: "#f9fbfc",
        overflow: "auto",
      }}
    >
      <Toolbar />

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
            flexDirection: "column",
          }}
        >
          <CircularProgress size={50} />
          <Typography variant="h6" sx={{ mt: 2 }}>
            Loading surveillance system...
          </Typography>
        </Box>
      ) : selectedPlace ? (
        <Fade in={!!selectedPlace} timeout={800}>
          <Box>
            <CameraGrid
              cameras={cameras}
              searchCamera={searchCamera}
              onCameraClick={onCameraClick}
              theme={theme}
              columns={columnCount}
              gridSize={gridSize}
            />
          </Box>
        </Fade>
      ) : (
        <Box>
          <CameraGrid
            cameras={cameras}
            searchCamera={searchCamera}
            onCameraClick={onCameraClick}
            theme={theme}
            columns={columnCount}
            gridSize={gridSize}
          />
        </Box>
      )}
    </Box>
  );
};

export default MainContent;